import request from 'graphql-request'
import getWpUrlFromLang from '@/backend/wp'
import { PageIdType } from 'gql/graphql'
import { QUERY_NEWS_PER_PAGE, QUERY_TEAM_NUMBER_COUNT } from '../../../const'
import { graphql } from '../../gql'

export const nouvelles = graphql(/* GraphQL */ `
  query nouvelles($id: ID! = "nouvelles", $idType: PageIdType = URI, $asPreview: Boolean = false, $first: Int) {
    page(id: $id, idType: $idType, asPreview: $asPreview) {
      title
      content
      seo {
        ...SeoData
      }
      translatedUri
    }
    members(first: $first) {
      ...AllMembers
    }
    mainMenu: menuItems(where: { location: PRIMARY_MENU, parentId: 0 }) {
      ...MainMenu
    }
  }
`)

export const allPosts = graphql(/* GraphQL */ `
  query allPosts($first: Int) {
    posts(first: $first) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        slug
        uri
        title
        date
        categories {
          nodes {
            name
          }
        }
      }
    }
  }
`)

export const allPostsPerCat = graphql(/* GraphQL */ `
  query allPostsPerCat($first: Int, $category: String, $after: String) {
    posts(first: $first, after: $after, where: { categoryName: $category }) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        slug
        uri
        title
        date
        categories {
          nodes {
            name
          }
        }
      }
    }
  }
`)

export const allNewsCategories = graphql(/* GraphQL */ `
  query allNewsCategories {
    categories {
      nodes {
        id
        slug
        name
      }
    }
  }
`)
export async function getAllPostsPerCat(category: string, after = '', language?: string) {
  const url = language === 'en' ? '/en/graphql' : '/wp/graphql'
  const data = await request(url, allPostsPerCat, {
    first: QUERY_NEWS_PER_PAGE,
    category,
    after,
  })

  return data
}

async function nouvellesPage(id: string, language?: string) {
  const wpUrl = getWpUrlFromLang(language)
  const idType = PageIdType.Uri
  const data = await request(wpUrl, nouvelles, {
    id,
    idType,
    asPreview: false,
    first: QUERY_TEAM_NUMBER_COUNT,
    language,
  })

  const allNewsCategoriesData = await request(wpUrl, allNewsCategories)

  const allNews = await request(wpUrl, allPosts, {
    first: QUERY_NEWS_PER_PAGE,
  })

  return { ...data, ...allNews, ...allNewsCategoriesData }
}

export default nouvellesPage
